import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Drží stav „zamčené relace“. Když tiché obnovení tokenu (AuthInterceptor)
 * definitivně selže — např. po vypršení refresh tokenu nebo deaktivaci účtu —
 * místo tvrdého odhlášení a přesměrování na /auth/login jen zamkneme obrazovku.
 * LockScreenComponent pak nad aktuální stránkou zobrazí overlay pro rychlé
 * odemčení heslem (e-mail je předvyplněný), takže uživatel neztratí kontext.
 */
@Injectable({ providedIn: 'root' })
export class SessionLockService {
  private lockedSubject = new BehaviorSubject<boolean>(false);
  public locked$ = this.lockedSubject.asObservable();

  public get isLocked(): boolean {
    return this.lockedSubject.value;
  }

  lock(): void {
    if (!this.lockedSubject.value) {
      this.lockedSubject.next(true);
    }
  }

  unlock(): void {
    if (this.lockedSubject.value) {
      this.lockedSubject.next(false);
    }
  }
}
